(ns app.front.user-settings
  "This data is shared across sessions and preserved after logout, so it should be used for
  display settings and other low-stakes stuff only"
  (:require [app.front.util :as futil]
            [cljs.reader :as reader]
            [re-frame.core-instrumented :as rf]
            [schema.core :as s]))


(def storage-key "user-settings")


(defn- load []
  (try
    (-> storage-key
        futil/local-storage-get
        reader/read-string)
    (catch js/Error e
      (js/console.warn "Failed to read user settings from local storage" e)
      nil)))


(defn- save [data]
  (try
    (futil/local-storage-set! storage-key (pr-str data))
    (catch js/Error e
      (js/console.warn "Failed to save user settings to local storage" e)
      nil)))


(rf/reg-event-fx ::save-user-settings
  (fn [_ [_ path value schema]]
    (let [data (or (load) {})]
      (cond->> value
        ^boolean js/goog.DEBUG (s/validate schema)
        :always (assoc-in data path)
        :always save))))


(defn get-value [path schema]
  (let [data   (get-in (load) path)
        errors (some-> (and data schema) (s/check data))]
    (when (and ^boolean js/goog.DEBUG errors)
      (js/console.warn "User data loaded with path"
                       (pr-str path)
                       "does not match schema, errors:"
                       (pr-str errors)))
    (when-not errors data)))
